export const defaultSelectedDateFrom = () => {
    var fecha = new Date();
    let before = new Date(fecha.getFullYear(), fecha.getMonth() - 6, 1)
    const year = before.getFullYear();
    const month = String(before.getMonth() + 1).padStart(2, '0');
    const day = '01';
    return `${year}-${month}-${day}`;

};
export default {
  params: {
    paginate: false,
    product: "",
    branchoffice_warehouse_id: "",
    branchoffice: null,
    destination_branchoffice_warehouse_id: "",
    destination_branchoffice: null,
    filter: "",
    page: 1,
    contact_id: null,
    perPage: 15,
    inactives:0,
    with_stock:0,
    apply_filter_only_consignment_products: false,
    only_consignment_products: false,
  },
  titleBranchoffice: "",
  products: [],
  contacts: [],
  params_contacts:{
        is_customer: true,
        is_provider: false,
        is_employee: false,
        paginate: false,
        page: 1,
        perPage: 50,
        query: '',
        filter: '',
        sortBy: 'id',
        sort: 'ASC',
        only_active:true,
    },
  productspagination: {
    from: null,
    to: null,
    total: null
  },
  availability: [],
  availability_totals: [],
  justify_availability: [],
  params_location: {
    product: null,
    branchoffice_warehouse: null,
    location: null,
    warehouse_id: null
  },
  branch_offices_warehouses: [],
  params_history_products:{
      date_from : defaultSelectedDateFrom(),
      contact_id : null,
      product_id : null,
      branchoffice_id : null,
      paginate : true,
      perPage : 15,
      page : 1,
      loading : false,
  },
  history_products:[],
  branchoffice_warehouse: null
};



// WEBPACK FOOTER //
// ./src/modules/availability-inquiry/state.js